export default class ConflictResolver {
    constructor(parent) {
        this.parent = parent;
        this.data = parent.data;
        this.pricing = parent.pricing;
        this.wheels = this.data.wheels.map((w) => w.partNumber);
    }

    resolve(tempCar, conflict, choiceType, choiceId, dryRun) {
        if (conflict.type === 'noGradeEngine') {
            this.resolveNoGradeEngine(tempCar, choiceType, choiceId, dryRun); // No grade/engine combination exists for current car
        } else if (conflict.type === 'noColourTrim') {
            this.resolveNoColourTrim(tempCar, choiceType, choiceId, dryRun); // No colour/trim combination exists for current car
        } else if (conflict.type === 'noWheels') {
            this.resolveNoWheels(tempCar, choiceType, choiceId, dryRun); // No wheels added to current car
        } else if (conflict.type === 'tooManyWheels') {
            this.resolveTooManyWheels(tempCar, choiceType, choiceId, dryRun); // More than one wheel added to current car
        } else if (conflict.type === 'noCarWheel') {
            this.resolveNoCarWheel(tempCar, choiceType, choiceId, dryRun); // Car has wheels, but not allowed on the current car
        } else if (conflict.type === 'noCarAccessory') {
            this.resolveNoCarAccessory(tempCar, choiceType, choiceId, dryRun); // Car has accessories that are not allowed on current car
        } else if (conflict.type === 'accessoryConflict') {
            this.resolveAccessoryConflict(tempCar, choiceType, choiceId, dryRun); // Car has accessories that conflict with one another
        } else if (conflict.type === 'accessoryColour') {
            this.resolveAccessoryColour(tempCar, choiceType, choiceId, dryRun); // Car has accessory in wrong colour, but accessory has variant in correct colour
        } else if (conflict.type === 'noAccessoryColour') {
            this.resolveNoAccessoryColour(tempCar, choiceType, choiceId, dryRun); // Car has accessory in wrong colour and accessory doesnt not have variant in correct colour
        } else if(conflict.type === 'incorrectMandatoryEuroOption') {
            this.resolveIncorrectMandatoryEuroOption(tempCar, choiceType, choiceId, dryRun); // Car incorrect mandatory euro option
        } else if (conflict.type === 'noEuroOptionBundle') {
            this.resolveNoEuroOptionBundle(tempCar, choiceType, choiceId, dryRun); // Car does not have euro option for current accessories in pricing data
        } else if(conflict.type === 'missingIncludedAdditionalProduct') {
            this.resolveMissingIncludedAdditionalProduct(tempCar, choiceType, choiceId, dryRun); // Car missing included additional product
        } else if(conflict.type === 'hasIncompatibleAdditionalProduct') {
            this.resolveHasIncompatibleAdditionalProduct(tempCar, choiceType, choiceId, dryRun); // Car has incompatible additional product
        } else if(conflict.type === 'missingMustHaveAdditionalProduct') {
            this.resolveMissingMustHaveAdditionalProduct(tempCar, choiceType, choiceId, dryRun); // Car missing must have additional product
        } else if(conflict.type === 'missingDiscountedToZeroAdditionalProduct') {
            this.resolveMissingDiscountedToZeroAdditionalProduct(tempCar, choiceType, choiceId, dryRun); // Car missing discounted to zero additional product
        }
    }

    resolveNoGradeEngine(tempCar, choiceType, choiceId, dryRun) {
        // Find car that matches selected grade or engine, or fallback prioritizing previous choices.
        const car = this.data.cars.find((c) => choiceType === 'grade' && c.gradeCode === choiceId)
            || this.data.cars.find((c) => choiceType === 'engine' && c.engineTDCode === choiceId)
            || this.data.cars.find((c) => c.gradeCode === tempCar.grade)
            || this.data.cars.find((c) => c.engineTDCode === tempCar.engine)
            || this.data.cars[0];
        tempCar.grade = car.gradeCode;
        tempCar.engine = car.engineTDCode;
        this.log('noGradeEngine - Updating', tempCar, choiceType, dryRun);
    }

    resolveNoColourTrim(tempCar, choiceType, choiceId, dryRun) {
        let car = tempCar.data();
        if (choiceType === 'colour' || choiceType == 'trim') {
            let colourTrim = car.colourTrims.find((ct) => choiceType === 'colour' && ct.colour === choiceId && ct.trimDefault === 'true')
                            || car.colourTrims.find((ct) => choiceType === 'colour' && ct.colour === choiceId)
                            || car.colourTrims.find((ct) => choiceType === 'trim' && ct.trim === choiceId && ct.colourDefault === 'true')
                            || car.colourTrims.find((ct) => choiceType === 'trim' && ct.trim === choiceId);
            if (colourTrim) { // If selecting a colour or trim and there is a combination on the current car that matches
                // Update colour/trim
                tempCar.colour = colourTrim.colour;
                tempCar.trim = colourTrim.trim;
                this.log('noColourTrim - Updating colour trim', tempCar, choiceType, dryRun);
            } else { // If selecting a colour or trim and there is no combination on the current car that matches
                // Find car that does colour/trim (prioritize both)
                car = this.data.cars.find((c) => c.colourTrims.some((ct) => ct.colour === tempCar.colour && ct.trim === tempCar.trim))
                        || this.data.cars.find((c) => choiceType === 'colour' && c.colourTrims.some((ct) => ct.colour === choiceId))
                        || this.data.cars.find((c) => choiceType === 'trim' && c.colourTrims.some((ct) => ct.trim === choiceId))
                        || this.data.cars[0];
                // Find colour/trim (prioritize both)
                colourTrim = car.colourTrims.find((ct) => ct.colour === tempCar.colour && ct.trim === tempCar.trim)
                                || car.colourTrims.find((ct) => choiceType === 'colour' && ct.colour === choiceId && ct.trimDefault === 'true')
                                || car.colourTrims.find((ct) => choiceType === 'colour' && ct.colour === choiceId)
                                || car.colourTrims.find((ct) => choiceType === 'trim' && ct.trim === choiceId && ct.colourDefault === 'true')
                                || car.colourTrims.find((ct) => choiceType === 'trim' && ct.trim === choiceId)
                                || car.colourTrims.find((ct) => ct.colourDefault === 'true' && ct.trimDefault === 'true')
                                || car.colourTrims.find((ct) => ct.colourDefault === 'true')
                                || car.colourTrims.find((ct) => ct.trimDefault === 'true')
                                || car.colourTrims[0];
                // Update car and colour/trim
                tempCar.grade = car.gradeCode;
                tempCar.engine = car.engineTDCode;
                tempCar.colour = colourTrim.colour;
                tempCar.trim = colourTrim.trim;
                this.log('noColourTrim - Updating car and colour trim', tempCar, choiceType, dryRun);
            }
        } else { // If selecting grade/engine and the current colour/trim combination does not exist
            // Find colour trim (try to keep colour/trim)
            const colourTrim = car.colourTrims.find((ct) => ct.colour === tempCar.colour && ct.trimDefault === 'true')
                            || car.colourTrims.find((ct) => ct.colour === tempCar.colour)
                            || car.colourTrims.find((ct) => ct.trim === tempCar.trim && ct.colourDefault === 'true')
                            || car.colourTrims.find((ct) => ct.trim === tempCar.trim)
                            || car.colourTrims.find((ct) => ct.colourDefault === 'true' && ct.trimDefault === 'true')
                            || car.colourTrims.find((ct) => ct.colourDefault === 'true')
                            || car.colourTrims.find((ct) => ct.trimDefault === 'true')
                            || car.colourTrims[0];
            // Update colour/trim
            tempCar.colour = colourTrim.colour;
            tempCar.trim = colourTrim.trim;
            this.log('noColourTrim - Updating colour trim', tempCar, choiceType, dryRun);
        }        
    }

    resolveNoWheels(tempCar, choiceType, choiceId, dryRun) {
        const car = tempCar.data();
        // Change to car default wheel if wheel was removed
        tempCar.accessories.push(car.defaultWheel);
        this.log('noWheels - Adding wheel', tempCar, choiceType, dryRun);
    }

    resolveTooManyWheels(tempCar, choiceType, choiceId, dryRun) {
        // Remove all but last wheel added
        const wheel = tempCar.accessories.findLast((a) => this.wheels.includes(a));
        tempCar.accessories = tempCar.accessories.filter((a) => !this.wheels.includes(a) || a === wheel);
        this.log('tooManyWheels - Removing wheels', tempCar, choiceType, dryRun);
    }

    resolveNoCarWheel(tempCar, choiceType, choiceId, dryRun) { // Car has wheels but they are not allowed on current car
        if (choiceType === 'accessories') { // If adding wheel
            // Find car that does updated wheel
            const car = this.data.cars.find((c) => c.accessories.includes(choiceId));
            // Update grade/engine
            tempCar.grade = car.gradeCode;
            tempCar.engine = car.engineTDCode;
            this.log('noCarWheel - Updating car', tempCar, choiceType, dryRun);
        } else { // Changed grade/engine and existing wheel no longer matches
            const car = tempCar.data();
            const wheel = tempCar.accessories.find((a) => this.wheels.includes(a));
            // Remove existing car wheel and add default car wheel
            tempCar.accessories = tempCar.accessories.filter((a) => a !== wheel);
            tempCar.accessories.push(car.defaultWheel);
            this.log('noCarWheel - Replacing wheels', tempCar, choiceType, dryRun);
        }
    }

    resolveNoCarAccessory(tempCar, choiceType, choiceId, dryRun) {
        if (choiceType === 'accessories') { // If adding accessory that is not allowed on current car
            // Find car that allows added accessory
            const car = this.data.cars.find((c) => c.accessories.includes(choiceId));
            // Update grade/engine
            tempCar.grade = car.gradeCode;
            tempCar.engine = car.engineTDCode;
            // Remove any accessories not allowed up updated car
            tempCar.accessories = tempCar.accessories.filter((a) => car.accessories.includes(a));
            this.log('noCarAccessory - Updating car and accessories', tempCar, choiceType, dryRun);
        } else { // If changing grade/engine and existing accessory is not longer allowed on updated car
            const car = tempCar.data();
            // Remove any accessories that the updated car doesnt support
            tempCar.accessories = tempCar.accessories.filter((a) => car.accessories.includes(a));
            this.log('noCarAccessory - Updating accessories', tempCar, choiceType, dryRun);
        }
    }

    resolveAccessoryConflict(tempCar, choiceType, choiceId, dryRun) {
        if (choiceType === 'accessories') { // If adding accessory and it conflicts with a previously chosen accessory
            // Find accessories that conflict with added accessory (both directions)
            const choiceNotCompatible = tempCar.accessories.filter((a) => this.data.accessories[choiceId].notCompatibleWith.includes(a));
            const notCompatibleChoice = tempCar.accessories.filter((a) => this.data.accessories[a].notCompatibleWith.includes(choiceId));
            if (choiceNotCompatible.length || notCompatibleChoice.length) { // If there are accessories that conflict with the added accessory
                // Remove any accessories which conflict with accessory choice
                tempCar.accessories = tempCar.accessories.filter((a) => !choiceNotCompatible.includes(a) && !notCompatibleChoice.includes(a));
                this.log('accessoryConflict - Updating accessories', tempCar, choiceType, dryRun);
            } else { // This shouldnt happen, but there are conflicting accessories that are not the added accessory. Here as failsafe.
                const notCompatibleWith = tempCar.accessories
                    .map((a) => this.data.accessories[a])
                    .filter((acc) => acc)
                    .flatMap((acc) => (acc.notCompatibleWith));
                // Find first accessory which conflicts with another, will loop for subsequent accessories (to remove only accessories that are neccessary)
                const conflict = tempCar.accessories.find((a) => notCompatibleWith.includes(a));
                // Remove conflicting accessory
                tempCar.accessories = tempCar.accessories.filter((a) => a !== conflict);
                this.log('accessoryConflict - Updating accessories', tempCar, choiceType, dryRun);
            }
        } else { // This shouldnt happen, but could occur if conflicting accessories are present from old deeplinks. Here as failsafe.
            const notCompatibleWith = tempCar.accessories
                .map((a) => this.data.accessories[a])
                .filter((acc) => acc)
                .flatMap((acc) => (acc.notCompatibleWith));
            // Find first accessory which conflicts with another.
            const conflict = tempCar.accessories.find((a) => notCompatibleWith.includes(a));
            // Remove conflicting accessory
            tempCar.accessories = tempCar.accessories.filter((a) => a !== conflict);
            this.log('accessoryConflict - Updating accessories', tempCar, choiceType, dryRun);
        }
    }

    resolveAccessoryColour(tempCar, choiceType, choiceId, dryRun) {
        const accessories = tempCar.accessories
            .map((a) => this.data.accessories[a])
            .filter((a) => a);
        const accessoryColour = accessories.find((a) => a.extColour && a.extColour != tempCar.colour);
        // Switch accessory with incorrect colour to its variant in the current colour;
        tempCar.accessories = tempCar.accessories
                                    .map((a) => (a === accessoryColour?.partNumber ? accessoryColour?.colours?.[tempCar.colour] : a))
                                    .filter((a) => a);
        console.log('accessoryColour - Updating accessories', tempCar, choiceType, dryRun);
    }

    resolveNoAccessoryColour(tempCar, choiceType, choiceId, dryRun) {
        const accessoryColour = tempCar.accessories
            .map((a) => this.data.accessories[a])
            .filter((a) => a)
            .find((a) => a.extColour != tempCar.colour && !a.colours[tempCar.colour]);
        // Remove with incorrect colour with no variant in current colour
        tempCar.accessories = tempCar.accessories.filter((a) => a !== accessoryColour.partNumber);
        this.log('noAccessoryColour - Updating accessories', tempCar, choiceType, dryRun);
    }

    resolveIncorrectMandatoryEuroOption(tempCar, choiceType, choiceId, dryRun) {
        const mtoPricing = this.pricing.getCarMTOPricing(tempCar.mto());
        const euroOptions = mtoPricing?.c_euroOptions ?? [];
        const includedEuroOption = euroOptions.find((eo) => eo.c_isMandatory)?.ean;
        // Set the mandatory euro option to the one in the pricing data otherwise it wil be null if there is not one
        tempCar.mandatoryEuroOption = includedEuroOption;
        this.log('incorrectMandatoryEuroOption - Setting mandatory euro option', tempCar, choiceType, dryRun);
    }

    resolveNoEuroOptionBundle(tempCar, choiceType, choiceId, dryRun) {
        //If there are more than 1 accessory
        if(tempCar.accessories.length > 1) {
            // Remove first accessory that is not the one being chosen
            const first = tempCar.accessories.find((acc) => acc !== choiceId);
            tempCar.accessories = tempCar.accessories.filter((acc) => acc != first);
        } else {
            // Remove all accessories
            tempCar.accessories = [];
        }
        this.log('noEuroOptionBundle - Updating accessories', tempCar, choiceType, dryRun);
    }

    resolveMissingIncludedAdditionalProduct(tempCar, choiceType, choiceId, dryRun) {
        const mtoPricing = this.pricing.getCarMTOPricing(tempCar.mto());
        const includedAdditionalProducts = mtoPricing?.c_additionalProducts?.filter((ap) => ap.additionalProductIncluded)?.map((ap) => ap.ean) ?? [];
        const missingIncludedAdditionalProducts = includedAdditionalProducts.filter((ap) => !tempCar.additionalProducts.includes(ap)) ?? [];
        tempCar.additionalProducts.push(...(missingIncludedAdditionalProducts ?? []));
        this.log('missingIncludedAdditionalProduct - Adding missing additional products', tempCar, choiceType, dryRun);
    }

    resolveMissingDiscountedToZeroAdditionalProduct(tempCar, choiceType, choiceId, dryRun) {
        const additionalProducts = this.pricing.getAdditionalProductsMTO(tempCar.mto());
        const notIncludedAndDiscountedToZero = (ap) => !ap.additionalProductIncluded && ap.c_priceAfterDiscount === 0;
        const includedOrDiscountedToZero = (ap) => ap.additionalProductIncluded || ap.c_priceAfterDiscount === 0;
        const mustHavesIncludedOrDiscountedToZero = (ap) => !ap.mustHave || ap.mustHave
                ?.map((ap) => this.pricing.getAdditionalProductMTO(ap, tempCar.mto()))
                ?.every((ap) => includedOrDiscountedToZero(ap));
        //Get additional products that are not already included, discounted to zero and all its must haves are also either included or discounted to zero
        const discountedToZeroAdditionalProducts = additionalProducts.filter((ap) => notIncludedAndDiscountedToZero(ap) && mustHavesIncludedOrDiscountedToZero(ap))?.map((ap) => ap.ean) ?? [];
        const missingDiscountedToZeroAdditionalProduct = discountedToZeroAdditionalProducts.filter((ap) => !tempCar.additionalProducts.includes(ap)) ?? [];
        tempCar.additionalProducts.push(...(missingDiscountedToZeroAdditionalProduct ?? []));
        this.log('missingDiscountedToZeroAdditionalProduct - Adding discounted to zero additional products', tempCar, choiceType, dryRun);
    }

    resolveHasIncompatibleAdditionalProduct(tempCar, choiceType, choiceId, dryRun) {
        const carAdditionalProducts = this.pricing.getCarAdditionalProducts({ tempCar });
        const hasIncompatible = carAdditionalProducts.filter((ap) => ap.cantHave?.some((cantHave) => tempCar.additionalProducts.includes(cantHave)));
        // If the additional product with incompatible products is the one being added
        if(choiceType === 'additionalProducts' && hasIncompatible.some((ap) => ap.ean === choiceId)) {
            const added = hasIncompatible.find((ap) => ap.ean === choiceId);
            const cantHave = added?.cantHave ?? [];
            const cantHaveDependants = carAdditionalProducts.filter((ap) => ap.mustHave?.some((mustHave) => cantHave.includes(mustHave)))?.map((ap) => ap.ean) ?? [];
            const remove = [ ...cantHave, ...cantHaveDependants];
            // Remove any incompatible products with the once being selected (and any products that are dependent on them)
            tempCar.additionalProducts = tempCar.additionalProducts.filter((ap) => !remove.includes(ap));
        } else {
            const selectedAccessory = carAdditionalProducts.find((ap) => ap.ean === choiceId);
            // Prioritise the selected accessory and its must haves
            const keep = [ selectedAccessory.ean, ...(selectedAccessory.mustHave ?? []) ];
            // Find the first incompatible additional product prioritizing the keep list 
            const remove = hasIncompatible.find((ap) => !keep.includes(ap.ean)) ?? hasIncompatible[0];
            tempCar.additionalProducts = tempCar.additionalProducts.filter((ap) => ap !== remove?.ean);
        }
        this.log('hasIncompatibleAdditionalProduct - Removing incompatible additional products', tempCar, choiceType, dryRun);
    }

    resolveMissingMustHaveAdditionalProduct(tempCar, choiceType, choiceId, dryRun) {
        const carAdditionalProducts = this.pricing.getCarAdditionalProducts({ tempCar });
        const missingMustHave = carAdditionalProducts.filter((ap) => ap.mustHave?.some((mustHave) => !tempCar.additionalProducts.includes(mustHave)));
        //If a product is being removed and another product has it in its must haves
        if(choiceType === 'additionalProducts' && missingMustHave.some((ap) => ap.mustHave.includes(choiceId))) {
            const remove = missingMustHave.find((ap) => ap.mustHave.includes(choiceId));
            //Remove the product which relies on the product being removed
            tempCar.additionalProducts = tempCar.additionalProducts.filter((ap) => ap !== remove?.ean);
        } else {
            const first = missingMustHave[0];
            //Else add the first products must haves
            tempCar.additionalProducts.push(...(first?.mustHave ?? []));
        }
        this.log('missingMustHaveAdditionalProducts - Adding missing must have additional products', tempCar, choiceType, dryRun);
    }

    log(...data) {
        if(!data.pop()) {
            console.log(...data);
        }
    }
}
